import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { useSWRConfig } from 'swr';

import { enqueueSnackbar } from '@/providers/SnackbarProvider';
import { usePrivate } from './PrivateContext';
import { acceptEulaMessages } from './messages';

export function useEulaAcceptanceFlow() {
  const { instance } = useMsal();
  const { mutate } = useSWRConfig();

  const { userId, userProfile, userProfileApi } = usePrivate();

  const [eulaDialogOpen, setEulaDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userProfile && !userProfile.isEulaAccepted) {
      setEulaDialogOpen(true);
    }
  }, [userProfile]);

  const handleClickBackEula = () => {
    instance.logout({ postLogoutRedirectUri: '/' });
  };

  const handleClickAcceptEula = () => {
    if (userId && userProfile && userProfileApi && !loading) {
      setLoading(true);
      userProfileApi
        .apiUserProfileAcceptEulaPatch({ userId })
        .then(() => {
          setEulaDialogOpen(false);
          mutate(`/api/UserProfile/${userId}`);
        })
        .catch((error) => {
          enqueueSnackbar(acceptEulaMessages['acceptEula.unexpctedError'], {
            variant: 'error',
          });
          console.error(
            '[BREEDLOGIC] useEulaAcceptanceFlow:handleClickAcceptEula - Error accepting EULA',
            error,
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return {
    isAcceptingEula: loading,
    userProfile,
    eulaDialogOpen,
    onClickBackEula: handleClickBackEula,
    onClickAcceptEula: handleClickAcceptEula,
  };
}
